import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { endPoints } from "../../Constant/Environment";
import { addItem, getAllItemsData } from "../../Utility/Api";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../Loader/index";
import swal from 'sweetalert';
import { Country, State, City } from 'country-state-city';
import CitySelectors from "../CitySelector/CitySelectors";
import { useModal } from '../../ModalContext';


function Register() {

  const { handleSecondModalClose,handleThirdModalOpen,handleFirstModalOpen } = useModal();

  const countryList = Country.getAllCountries();
  const cityList = City.getAllCities();
  const [fromWhere, setFromWhere] = useState("");
  const [cityName, setcityName] = useState("");
  const [stateName, setStateName] = useState("");
  const [countryName, setcountryName] = useState("");
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoadinig] = useState(false);
  const [isTravelerLoading, setIsTravelerLoadinig] = useState(false);
  const [states, setState] = useState([]);
  const [cities, setCity] = useState([]);

  function validateMobile(phoneNumber) {
    const phoneNumberPattern = /^(\d{3}-\d{3}-\d{4}|\d{10})$/;
    return phoneNumberPattern.test(phoneNumber);
  }
  const validateEmail = (value) => {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(value);
  };

  function validatePassword(password) {
    const alphaNumericRegex = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{5,}$/;
    return alphaNumericRegex.test(password);
  }
  function validateUsername(username) {
    const hasLetter = /[a-zA-Z]/.test(username);
    const hasNumber = /\d/.test(username);
    const hasMinimumLength = username.length >= 5;

    return hasLetter && hasNumber && hasMinimumLength;
  }

  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');

  const [formData, setFormData] = useState({
    first_name: '',
    email: '',
    mobile: '',
    country_name: '',
    state_name: '',
    city_name: '',
    username: '',
    password: '',
    gender: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: '',
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = 'Name is required';
    }

    if (!formData.gender.trim()) {
      newErrors.gender = 'Gender is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = 'Mobile No is required';
    } else if (!validateMobile(formData.mobile)) {
      newErrors.mobile = 'Mobile  is invalid';
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    } else if (!validatePassword(formData.password)) {
      newErrors.password = 'Password is not strong';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const isValid = validateForm();

    if (isValid) {
      try {
        const url = `${endPoints.api.UserRegister}`;
        if (!stateName && !countryName && !cityName) {
          console.log('All field required');
          setErrors({ ...errors, general: 'Please select loaction' });
          return;
        }
        formData.state_name = stateName;
        formData.country_name = countryName;
        formData.city_name = cityName;
        const response = await addItem(url, formData);
        if (response.status === 200) {

          const timeoutId = setTimeout(() => {
            handleSecondModalClose();
            handleFirstModalOpen();
            swal('Success!', response.message, 'success');
            setSuccess(response.message);
            setFormData({
              first_name: '',
              email: '',
              mobile: '',
              country_name: '',
              state_name: '',
              city_name: '',
              password: '',
            });
            setIsLoadinig(false);
            setSuccess('');
          }, 1000);
          timeoutId();
        } else {
          setIsLoadinig(false);
          setErrors({ ...errors, general: response.message });
        }
      } catch (error) {
        setIsLoadinig(false);
        setErrors({ ...errors, general: error.response });


      }

    }
  };



  useEffect(() => {
    const getLocationAndFetchData = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
          (err) => {
            setError(err.message);
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    getLocationAndFetchData();
  }, []);
 
  return (
    <>

      <main className="bg-white">
        <section className="p-3 login-page">



          <Row className="work-box rounded-0 border-0 align-items-center justify-content-center ">
            <Col md={10}>
              {success === '' ? null : <div className="alert alert-success ChangeColor">{success}</div>}

              {isLoading && <Loader spinner={true} visible={isLoading} className="LoaderForm" />}


              <Form validated={validated}
                onSubmit={handleSubmit} className="Reative row">
                {errors.general && (<small className="text-danger">{errors.general}</small>)}

                <Form.Group className="mb-3 col-md-6 " controlId="formBasicEmail">
                  <Form.Control
                    type="text"
                    name="first_name"
                    placeholder="Enter Your Name*"
                    value={formData.first_name}
                    onChange={handleInputChange}
                  />
                  {errors.first_name && (<small className="text-danger">{errors.first_name}</small>)}
                </Form.Group>

                <Form.Group
                  className="mb-3 col-md-6"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email Address*"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  {errors.email && (<small className="text-danger">{errors.email}</small>)}
                </Form.Group>
                <Form.Group
                  className="mb-3 col-md-6"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="number"
                    name="mobile"
                    placeholder="Mobile Number*"
                    value={formData.mobile}
                    onChange={handleInputChange}
                  />
                  {errors.mobile && (<small className="text-danger">{errors.mobile}</small>)}
                </Form.Group>
                <Form.Group className="mb-3 col-md-12 test" controlId="formBasicEmail">
                  <CitySelectors
                    location={location}
                    setDepartureCity={setFromWhere}
                    setcityName={setcityName}
                    setcountryName={setcountryName}
                    setStateName={setStateName}
                  />

                </Form.Group>

                <Form.Group className="mb-3 col-md-12 d-flex pt-3  " controlId="formBasicGender">
                  <Form.Label>Gender</Form.Label>

                  <div className="d-flex regi-set">
                    <Form.Check
                      type="checkbox"
                      id="maleCheckbox"
                      label="Male"
                      name="gender"
                      value="male"
                      checked={formData.gender === 'male'}
                      onChange={handleInputChange}
                    />

                    <Form.Check
                      className="regi-set"
                      type="checkbox"
                      id="femaleCheckbox"
                      label="Female"
                      name="gender"
                      value="female"
                      checked={formData.gender === 'female'}
                      onChange={handleInputChange}
                    />
                  </div>

                  {errors.gender && <small className="text-danger">{errors.gender}</small>}
                </Form.Group>
                {/* <Form.Group
                        className="mb-3 col-md-6"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="text"
                          name="username"
                          placeholder="User Name*"
                          value={formData.username}
                          onChange={handleInputChange}
                        />
                        <small>(Minimum length of 5 characters, letter,number.)</small>
                        {errors.username && (<small className="text-danger">{errors.username}</small>)}
                      </Form.Group> */}
                <Form.Group
                  className="mb-3 col-md-12"
                  controlId="formBasicPassword"
                >
                  <Form.Control type="password" placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                  <small>(Minimum length of 5 characters and alpha-numeric)</small>
                  {errors.password && (<small className="text-danger">{errors.password}</small>)}
                </Form.Group>
                <div className="justify-content-center d-flex">
                  <Button
                    // to="/"
                    onClick={handleSubmit}
                    variant="primary"
                    type="submit"
                    className="log-btn"
                  >
                    Register
                  </Button>
                </div>
                <Form.Text className="text-dark justify-content-center d-flex mt-4 fw-bold">
                      You have an account?
                      <span
                        className="loginf-sender"
                        onClick={handleFirstModalOpen}
                      >
                        Login
                      </span>
                    </Form.Text>
              </Form>
            </Col>

            <ToastContainer />


          </Row>
        </section>
      </main>
    </>
  );
}

export default Register;
